module.exports = __webpack_public_path__ + "static/media/peijian11.35a8b7ba.png";